import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import DeckPage from "./deck/DeckPage";
import AdminPage from "./admin/AdminPage";
import ImpiantiPage from "./pages/ImpiantiPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DeckPage />} />
          <Route path="/impianti" element={<ImpiantiPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
